import type { NewsSource, NewsSourcePath } from '../../../../api/DigiobcanApi';
import ConfirmationDialog from '../../../../components/ConfirmationDialog';
import FormAutocompleteField from '../../../../components/form/FormAutocompleteField';
import { __, requiredArray, toastError } from '../../../../utils';
import { decodePath, encodePath, sourceOptions } from '../newsSources';
import { Typography } from '@presov.sk/presov-ui-react';
import React from 'react';
import { Form } from 'react-final-form';

type Props = {
  open: boolean;
  /** Všetky zdrojové cesty s počtom noviniek (`GET /news-sources`). */
  sources: NewsSource[];
  /** Vzory, ktoré kategória už má - v ponuke nebudú. */
  existing: NewsSourcePath[];
  isLoading: boolean;
  onClose: () => void;
  onAdd: (paths: NewsSourcePath[]) => void;
};

const INITIAL_VALUES = { sources: [] as string[] };

/**
 * Pridanie zdrojov do kategórie. Ponuka obsahuje aj vyššie úrovne ciest
 * (`Úradná tabuľa` zahŕňa celú úradnú tabuľu) so súčtom noviniek pod nimi.
 */
const AddNewsCategorySourcesDialog: React.FC<Props> = ({
  open,
  sources,
  existing,
  isLoading,
  onClose,
  onAdd,
}) => {
  const options = React.useMemo(() => {
    const taken = new Set(existing.map(encodePath));
    return sourceOptions(sources).filter(({ value }) => !taken.has(value));
  }, [sources, existing]);

  return (
    <ConfirmationDialog
      open={open}
      title={__('Pridať zdroje do kategórie')}
      confirmLabel={__('Pridať')}
      formId='addSourcesForm'
      onClose={onClose}
      isLoading={isLoading}
      fullWidth
      maxWidth='sm'
    >
      <Form
        onSubmit={(values: { sources: string[] }) => {
          if (!navigator.onLine) {
            toastError(__('Internetové pripojenie zlyhalo.'));
            return;
          }
          onAdd(values.sources.map(decodePath));
        }}
        initialValues={INITIAL_VALUES}
      >
        {({ handleSubmit }) => (
          <form
            id='addSourcesForm'
            onSubmit={handleSubmit}
            style={{ display: 'flex', flexDirection: 'column', gap: 8 }}
          >
            <Typography variant='body2' color='text.secondary'>
              {__(
                'Novinka patrí do kategórie, keď jej zdroj začína niektorým zo zdrojov kategórie - „Úradná tabuľa" zahŕňa aj „Úradná tabuľa / Dražby". Jedna novinka môže byť vo viacerých kategóriách. V zátvorke je počet noviniek.',
              )}
            </Typography>
            <FormAutocompleteField
              name='sources'
              label={__('Zdroje')}
              options={options}
              multiple
              required
              validate={requiredArray}
              noOptionsText={__('Žiadny zdroj nesedí na hľadanie')}
            />
          </form>
        )}
      </Form>
    </ConfirmationDialog>
  );
};

export default AddNewsCategorySourcesDialog;
